import { GraphQlClient } from '@intelipost-js/secure-providers';

export default {
  enableRealtimeDetailQuotationReturn({ commit, dispatch }) {
    return GraphQlClient.mutation(`
      mutation{
        enableRealtimeDetailQuotationReturn{
          id
          is_active
        }
      }`,
      {},
    )
      .then((res) => {
        dispatch('quoteGetRealtimeStatus');
        return Promise.resolve(res);
      })
      .catch((err) => {
        dispatch('quoteGetRealtimeStatus');
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
  disableRealtimeDetailQuotationReturn({ dispatch }) {
    return GraphQlClient.mutation(`
      mutation{
        disableRealtimeDetailQuotationReturn{
          id
          is_active
        }
      }`,
      {},
    )
      .then((res) => {
        dispatch('quoteGetRealtimeStatus');
        return Promise.resolve(res);
      })
      .catch((err) => {
        dispatch('quoteGetRealtimeStatus');
        return Promise.reject(err);
      });
  },
  quoteGetRealtimeStatus({ commit }, args = {}) {
    return GraphQlClient.query(
      `query{
        getStatusRealtimeQuotation{
          id,
          is_active,
        }
      }`, args)
    .then((res) => {
      commit('setRealtimeStatus', res.data.getStatusRealtimeQuotation.is_active);
      return Promise.resolve(res.data.getStatusRealtimeQuotation.is_active);
    })
    .catch(err => Promise.reject(err));
  },
  quotegetIsEnableToShowRealtimeQuotation({ commit }, args = {}) {
    return GraphQlClient.query(
      `query{
        getIsEnableToShowRealtimeQuotation{
          enabled
        }
      }`, args)
    .then(res => Promise.resolve(res.data.getIsEnableToShowRealtimeQuotation.enabled))
    .catch(err => Promise.reject(err));
  },
  quoteGetLogistics({ commit }, args = {}) {
    return GraphQlClient.query(
      `query(
        $origin_zip_code: String!,
        ){
        deliveryMethodByZipCode(
          origin_zip_code: $origin_zip_code,
        ){
          id,
          name,
          shipment_type,
        }
      }`, args)
    .then((res) => {
      const {
        data,
      } = res;
      const {
        deliveryMethodByZipCode,
      } = data;
      commit('setDeliveryMethodList', deliveryMethodByZipCode);
      return Promise.resolve(res);
    })
    .catch(err => Promise.reject(err));
  },
  quoteGetContractsByDeliveryMethod({ commit }, args = {}) {
    return GraphQlClient.query(
      `query(
        $origin_zip_code: String!
        $delivery_method_id: String!) {
        deliveryMethodContractsByZipCode(
          origin_zip_code: $origin_zip_code
          delivery_method_id: $delivery_method_id
        ) {
          delivery_method {
            id
            current_contracts{
              id
              file_name
            }
            history_contracts{
              id
              file_name
            }
            draft_contracts{
              id
              file_name
            }
          }
        }
      }`, args)
    .then((res) => {
      const {
        data,
      } = res;
      const {
        deliveryMethodContractsByZipCode,
      } = data;

      const {
        delivery_method,
      } = deliveryMethodContractsByZipCode;
      const {
        delivery_method_id,
        delivery_method_name,
      } = args;
      commit('setContractList', { delivery_method, delivery_method_id, delivery_method_name });
      return Promise.resolve(res);
    })
    .catch(err => Promise.reject(err));
  },
  quoteByVolume({ commit }, form = {}) {
    commit('toggleLoading', true);

    const {
      configTransformed = {},
      skip_return_modes = false,
      skip_quote_rules = false,
      contract_ids = [],
      debug = false,
    } = form;

    const {
      origin_zip_code,
      destination_zip_code,
      volumes,
      additional_information,
      logistic_contract_mode,
      shipment_type,
    } = configTransformed;

    return GraphQlClient.mutation(`
      mutation(
        $skip_quote_rules: Boolean,
        $skip_return_modes: Boolean,
        $origin_zip_code: String!,
        $destination_zip_code: String!,
        $logistic_contract_mode: Boolean,
        $shipment_type: Boolean,
        $volumes: [VolumeInput]!,
        $contract_ids: [Int],
        $additional_information: AdditionalInformationInput,
        $debug: Boolean
      ){
      quoteFreightVolume(
        skip_quote_rules: $skip_quote_rules,
        skip_return_modes: $skip_return_modes,
        logistic_contract_mode: $logistic_contract_mode,
        shipment_type: $shipment_type,
        origin_zip_code: $origin_zip_code,
        destination_zip_code: $destination_zip_code,
        volumes: $volumes,
        contract_ids: $contract_ids,
        additional_information: $additional_information,
        debug: $debug
      ){
          id
          excluded_methods{
            delivery_restrictions,
            name,
            logo_url,
          }
          logistic_provider{
            delivery_methods{
              id,
              name,
              description,
              final_shipping_cost,
              delivery_estimate_minutes,
              delivery_estimate_minutes_to_day,
              delivery_estimate_date_minutes,
              delivery_estimate_date_minutes_iso,
              cost,
              delivery_estimate_business_days,
              type,
              note,
              logo_url,
              logistic_contract_id,
            }
          }
          order{
            qty_volumes
          }
        }
      }`,
      {
        origin_zip_code,
        destination_zip_code,
        volumes,
        additional_information,
        logistic_contract_mode,
        shipment_type,
        contract_ids,
        skip_quote_rules,
        skip_return_modes,
        debug,
      },
    )
      .then((res) => {
        const { data = {} } = res || {};
        const { quoteFreightVolume = {} } = data || {};
        commit('toggleLoading', false);
        commit('setquoteFreight', quoteFreightVolume);
        return Promise.resolve(res);
      })
      .catch((err) => {
        const quoteFreight = {
          excluded_methods: [],
          logistic_provider: {
            delivery_methods: [],
          },
          order: {
            qty_volumes: null,
          },
        };
        commit('setquoteFreight', Object.assign({}, quoteFreight));
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
  getWarehouseZipcode({ commit }) {
    commit('toggleLoading', true);

    return GraphQlClient.query(`
      query{
        warehouseZipcode{
          zip_code
        }
      }`)

      .then((res) => {
        const {
          data,
        } = res || {};

        const {
          warehouseZipcode,
        } = data || {};

        const {
          zip_code,
        } = warehouseZipcode || {};

        commit('setOriginZipCode', zip_code);
        commit('toggleLoading', false);
      });
  },

  quoteByProduct({ commit }, form = {}) {
    commit('toggleLoading', true);
    const {
      origin_zip_code,
      destination_zip_code,
      products,
      additional_information,
      logistic_contract_mode,
      shipment_type,
    } = form;
    return GraphQlClient.mutation(`
      mutation(
        $origin_zip_code: String!,
        $logistic_contract_mode: Boolean,
        $shipment_type: Boolean,
        $destination_zip_code: String!,
        $products: [ProductInput]!,
        $additional_information: AdditionalInformationInput
      ){
      quoteFreightProduct(
        origin_zip_code: $origin_zip_code,
        destination_zip_code: $destination_zip_code,
        products: $products,
        additional_information: $additional_information,
        logistic_contract_mode: $logistic_contract_mode,
        shipment_type: $shipment_type,
      ){
          id
          excluded_methods{
            delivery_restrictions,
            name,
            logo_url,
          }
          logistic_provider{
            delivery_methods{
              id,
              name,
              description,
              final_shipping_cost,
              cost,
              delivery_estimate_minutes,
              delivery_estimate_minutes_to_day,
              delivery_estimate_date_minutes,
              delivery_estimate_date_minutes_iso,
              delivery_estimate_business_days,
              type,
              note,
              logo_url,
              logistic_contract_id,
            }
          }
          order{
            qty_volumes
          }
        }
      }`,
      {
        origin_zip_code,
        destination_zip_code,
        products,
        additional_information,
        logistic_contract_mode,
        shipment_type,
      },
    )
      .then((res) => {
        const { data = {} } = res || {};
        const { quoteFreightProduct = {} } = data || {};
        commit('toggleLoading', false);
        commit('setquoteFreight', quoteFreightProduct);
        return Promise.resolve(res);
      })
      .catch((err) => {
        const quoteFreight = {
          excluded_methods: [],
          logistic_provider: {
            delivery_methods: [],
          },
          order: {
            qty_volumes: null,
          },
        };
        commit('setquoteFreight', Object.assign({}, quoteFreight));
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
  updateContractList({ commit }, object) {
    commit('setUpdateContractId', object);
  },
  cleanUpdateContractId({ commit }) {
    commit('cleanUpdateContractId');
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-quote/features/freight-quote/store/actions.js